// extracted by mini-css-extract-plugin
module.exports = {"DirectLessonViewer":"DirectLessonViewer_DirectLessonViewer__Po2-u","Header":"DirectLessonViewer_Header__13msa","icon":"DirectLessonViewer_icon__2iz09"};